import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setAnalyticsPlatform, trackPageView } from '../lib/analytics'

// Mount after <Routes>: useSeo must set document.title before this effect reads it.
export default function AnalyticsTracker({ platform }: { platform: string }) {
  const { pathname } = useLocation()

  useEffect(() => {
    setAnalyticsPlatform(platform)
  }, [platform])

  useEffect(() => {
    void trackPageView()
  }, [pathname])

  return null
}
